import isEmpty from "lodash-es/isEmpty";
import { Button, DeleteIcon } from "melco-ui";
import { useTranslation } from "react-i18next";
import { EfsMelcoEfsModelsUserFormatListItem } from "melco-shared-logic";
import { Key } from "antd/lib/table/interface";
import { useConfirm } from "../../hooks/useConfirm";
import { useDeleteInputFormats } from "../../hooks/inputFormats/useDeleteInputFormats";

type BulkActionDeleteInputFormatsProps<T> = {
  selectedRowKeys: Key[];
  setSelectedRowKeys: (keys: Key[]) => void;
  refetch?: () => Promise<any>;
  data?: T[];
};

export const BulkActionDeleteInputFormats: React.FC<
  BulkActionDeleteInputFormatsProps<EfsMelcoEfsModelsUserFormatListItem>
> = ({ selectedRowKeys, setSelectedRowKeys, refetch }) => {
  const { t } = useTranslation();
  const deleteInputFormats = useDeleteInputFormats();

  const confirmDelete = useConfirm(
    async () => {
      const successfullyDeletedIds = await deleteInputFormats(
        selectedRowKeys.map((key) => key.toString())
      );

      if (refetch) {
        refetch();
      }

      // keep items that were not deleted selected
      setSelectedRowKeys(
        selectedRowKeys.filter(
          (id) => !successfullyDeletedIds.includes(id.toString())
        )
      );
    },
    {
      translationPrefix: "inputFormats.actions.delete",
      translationOptions: {
        count: selectedRowKeys.length,
      },
    }
  );

  if (isEmpty(selectedRowKeys)) {
    return null;
  }

  return (
    <Button
      key="bulk-delete"
      icon={<DeleteIcon />}
      onClick={() => {
        confirmDelete();
      }}
    >
      {t("inputFormats.actions.delete.button")}
    </Button>
  );
};
